import { render, staticRenderFns } from "./HerramientasMensajes.vue?vue&type=template&id=21d3a9b6"
import script from "./HerramientasMensajes.vue?vue&type=script&lang=js"
export * from "./HerramientasMensajes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports